/**
 * 维护一个全局取消池，用于集中取消所有尚未完成的请求。
 * 注意：只存放“活跃中的” AbortController；请求结束后要及时释放。
 */
const abortPool = new Set<AbortController>()

/** 把外部 signal（若有）与内部 controller 绑定，外部取消时联动内部取消 */
function linkExternalSignal(external?: AbortSignal, controller?: AbortController) {
  if (!external || !controller) return
  if (external.aborted) {
    // 外部已取消则立即同步内部取消
    controller.abort()
    return
  }
  // 外部后续取消时，触发内部取消
  external.addEventListener('abort', () => controller.abort())
}

/**
 * 创建一个“已纳入取消池管理”的 AbortController。
 * - 会自动与外部 signal（如果传入）联动；
 * - 会自动加入全局 abortPool，方便统一取消；
 * - 调用方需在请求完成/失败时调用 releaseController 释放。
 */
export function makeTrackedController(externalSignal?: AbortSignal): AbortController {
  const controller = new AbortController()
  linkExternalSignal(externalSignal, controller)
  abortPool.add(controller)
  return controller
}

/** 将 controller 从取消池释放（请求完成/失败时务必调用，避免内存泄漏） */
export function releaseController(controller?: AbortController) {
  if (controller) abortPool.delete(controller)
}

/** 退出登录或全局重置时：集中取消所有未决请求 */
export function cancelAll() {
  abortPool.forEach((c) => c.abort())
  abortPool.clear()
}
